import { WarehousePickingObjectLocationView } from "src/api/generated/erp/db/types/tables/warehousePickingObjectLocationView.ts";
import { WarehousePickingObjectType } from "src/api/generated/erp/db/types/enums/warehousePickingObjectType.ts";

export interface DistributedPick {
	partId: number;
	objectType: WarehousePickingObjectType;
	objectId: number;
	quantityToPickInBaseUnit: number;
	partWarehouseLocationId: number | null | undefined;
}

export function distributePickingQuantity(
	requested: number,
	sourceLocations: WarehousePickingObjectLocationView[],
): DistributedPick[] {
	if (requested === 0) return [];

	const isReverting = requested < 0;

	let remaining = Math.abs(requested);
	const result: DistributedPick[] = [];

	for (const location of sourceLocations) {
		if (remaining <= 0) break;
		const availableQuantity = isReverting ? location.pickedQuantity : location.reservedQuantity;
		if (availableQuantity <= 0) continue;

		const quantityToPickInBaseUnit = Math.min(remaining, availableQuantity);
		if (quantityToPickInBaseUnit <= 0) continue;

		remaining -= quantityToPickInBaseUnit;
		result.push({
			partId: location.partId,
			objectType: location.objectType,
			objectId: location.objectId,
			quantityToPickInBaseUnit: isReverting ? -quantityToPickInBaseUnit : quantityToPickInBaseUnit,
			partWarehouseLocationId: location.partWarehouseLocationId,
		});
	}

	return result;
}
